import { atom } from 'jotai'
import type { Contact } from '@node-space/types'
import { ContactActionSheet, ContactInstrumentActionSheet } from 'types/atoms/atom.contacts'
import { ContactCase, ContactInstrument, ContactInstrumentDecisionStep } from 'types/contacts'

export const contactAtom = atom<Contact>({} as Contact)
contactAtom.debugLabel = 'contact'

export const editingContactAtom = atom(false)
editingContactAtom.debugLabel = 'editing-contact'

export const contactInstrumentAtom = atom<ContactInstrument>({} as ContactInstrument)
contactInstrumentAtom.debugLabel = 'contact-instrument'

export const editingContactInstrumentAtom = atom(false)
editingContactInstrumentAtom.debugLabel = 'editing-contact-instrument'

export const contactCaseCountAtom = atom<number>()

contactCaseCountAtom.debugLabel = 'contact-case-count'

export const contactCaseAtom = atom<ContactCase>({} as ContactCase)
contactCaseAtom.debugLabel = 'contact-case'

export const contactInstrumentDecisionStepAtom = atom<ContactInstrumentDecisionStep>(
  ContactInstrumentDecisionStep.CONTACT_DECISION
)
contactInstrumentDecisionStepAtom.debugLabel = 'contact-instrument-decision-step'

// Main contact action atom for general contact operations
export const contactActionAtom = atom<ContactActionSheet>({} as ContactActionSheet)
contactActionAtom.debugLabel = 'contact-action'

// Separate atom for mass payouts contact operations to avoid conflicts
export const massPayoutContactActionAtom = atom<ContactActionSheet>({} as ContactActionSheet)
massPayoutContactActionAtom.debugLabel = 'mass-payout-contact-action'

export const contactInstrumentActionAtom = atom<ContactInstrumentActionSheet>(
  {} as ContactInstrumentActionSheet
)
contactInstrumentActionAtom.debugLabel = 'contact-instrument-action'
